import Vue from 'vue';

// initial state
const initialUserInfo = {
  id: null,
  email: '',
  firstName: '',
  lastName: '',
  roles: [],
  broker: {
    name: null,
    logoUrl: null,
    colors: {
    },
  },
};

const moduleState = {
  // this is a global "panel" object, however in production we need one of these for each panel
  // so we would have one each for quote activity/comments/version history
  panel: {
    visible: false,
    open: false,
  },
  userInfo: initialUserInfo,
};
const moduleGetters = {
  panel: (state) => state.panel,
  primaryColor: (state) => state.userInfo.broker.colors.primaryColor,
  secondaryColor: (state) => state.userInfo.broker.colors.secondaryColor,
};
const moduleActions = {
  togglePanelV1({ commit }, open) {
    /*
      Opening a panel has two actions we make it as visible (this adds/removes it from the dom).
      We change the open property which is used to reference a css class.
      By doing these sepeartly and with a delay,
      it allows us to add it to the dom and then trigger a class change and a transition.
    */
    if (open) {
      commit('TOGGLE_PANEL_VISIBLE', open);
      window.setTimeout(() => {
        commit('TOGGLE_PANEL_OPEN', open);
      }, 500);
    } else {
      commit('TOGGLE_PANEL_OPEN', open);
      window.setTimeout(() => {
        commit('TOGGLE_PANEL_VISIBLE', open);
      }, 500);
    }
  },
  setUserInfo({ commit }, info) {
    commit('SET_USER_INFO', info);
  },
};
const moduleMutations = {
  TOGGLE_PANEL_VISIBLE(state, visible) {
    state.panel.visible = visible;
  },
  TOGGLE_PANEL_OPEN(state, open) {
    state.panel.open = open;
  },
  SET_USER_INFO(state, info) {
    Vue.set(state.userInfo, 'id', info.id);
    Vue.set(state.userInfo, 'email', info.email);
    Vue.set(state.userInfo, 'firstName', info.first_name);
    Vue.set(state.userInfo, 'lastName', info.last_name);
    Vue.set(state.userInfo, 'roles', info.roles);

    Vue.set(state.userInfo.broker, 'name', info.broker.name);
    Vue.set(state.userInfo.broker, 'logoUrl', info.broker.logo_url);

    if (info.broker.web_styling) {
      Vue.set(
        state.userInfo.broker,
        'colors',
        {
          primaryColor: info.broker.web_styling.primary_color,
          secondaryColor: info.broker.web_styling.secondary_color,
          primaryColorDarker: info.broker.web_styling.primary_color_variation1,
          primaryColorLight1: info.broker.web_styling.primary_color_variation2,
          primaryColorLight2: info.broker.web_styling.primary_color_variation3,
        },
      );
    }
  },
};

export default {
  state: moduleState,
  getters: moduleGetters,
  actions: moduleActions,
  mutations: moduleMutations,
};
